import { useEffect, useState } from "react";
import CompletedRoute from "./CompletedRoute";
import { useLazyGetCompletedRoutesQuery } from "Data/services/routesApi";
import { RouteWithDriver } from "Data/interfaces";
import { getCurrentDate } from "Helper";
import CustomLoader from "Components/CustomComponents/CustomLoader";
import NoDataFound from "Components/CustomComponents/NoDataFound";

const CompletedComponent: React.FC = () => {
  const [selectedDate] = useState<string>(getCurrentDate());
  const [routes, setRoutes] = useState<RouteWithDriver[]>([]);
  const [getCompletedRoutes, { isFetching }] = useLazyGetCompletedRoutesQuery();

  // console.log(routes);

  useEffect(() => {
    if (selectedDate) {
      getCompletedRoutes({ date: selectedDate }).then(({ data }) => {
        setRoutes(data?.data || []);
      });
    }
  }, [selectedDate]);

  return (
    <div className="d-flex flex-column gap-2 mt-2">
      {isFetching && routes.length === 0 && <CustomLoader />}
      {!isFetching && routes.length === 0 && <NoDataFound />}

      {routes.map((route, index) => {
        return <CompletedRoute key={index} route={route} />;
      })}
    </div>
  );
};

export default CompletedComponent;
